import ProductInfo, { ProductInfoProps } from './ProductInfo'
export default ProductInfo
export { ProductInfo }
export type { ProductInfoProps }
